var IpcPthPadGeneratorData = require('./ipcPthPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var PathType = require('../../../svg/pathType.js');
var PthComponentAttribute = require('./pthComponentAttribute.js');
var IPCRules = require('../ipcRules');
var IPCPthFootprintCalculator = require('./pthCalculator.js');

var RadialData = function(position, angle, init) {
    var self = this;
    IpcPthPadGeneratorData.apply(this, arguments);

    this.bodyColor = this.value("bodyColor", true);
    this.nonTransformedSegmentedGeometry.addTrigger(this.bodyColor);

    this.bodyWidthMax.onChange(this, function(value) {
        self.bodyLengthMax(value);
    });
    this.bodyWidthMin.onChange(this, function(value) {
        self.bodyLengthMin(value);
    });
};
lib_core.inherit(RadialData, IpcPthPadGeneratorData);
lib_core.JsonParser.registerClass(RadialData, "RadialData");

module.exports = RadialData;

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
RadialData.prototype.getPads = function(absolutePositions) {
    var pads = [];
    var motif = this.getMotif();
    var hPitch = this.verticalPinPitch();
    var pad = motif.clone();
    //left pad
    pad.move(new lib_geometry.Coord(-0.5 * hPitch, 0));
    pads.push(pad);

    //right pad
    pad = motif.clone();
    pad.move(new lib_geometry.Coord(0.5 * hPitch, 0));
    pads.push(pad);

    this.updatePads(pads, absolutePositions);

    return pads;
};

RadialData.prototype.getAssemblyOutline = function(pads) {
    if (pads.length === 0) return;

    var body = this.getBodyForAssembly();
    var outline = new EllipseData(new lib_geometry.Coord(0,0), 0, body.width, body.width, false, IPCRules.assemblyOutlineStrokeWidth);
    return outline;
};
